import React, { useState } from 'react';
import "./accordion2.css";

const Accordion2 = (props) => {
  const [isActive, setIsActive] = useState(false);
  
  var list="";
  var arraylist=[];
  if (props.content=='-'){
    list="nulla"
  }
  if(props.content!='-'){
    var cnt=props.content.toString();
    var countvirgole=(cnt.match(/,/g) || []).length;
    arraylist=cnt.split(",", countvirgole+1)
    console.log(arraylist)
  }

console.log(props.content)
  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div>{props.title}</div>
        <div>{isActive ? '-' : '+'}</div>
      </div>
      {isActive && <div className="accordion-content">{arraylist.map((item, key)=>(<p>{item}</p>))}</div>}
    </div>
  );
};

export default Accordion2;